<template>
  <div class="filter-status btnHover filter-source">
    <el-dropdown trigger="click" :hide-on-click="false">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_multiple_choice"></i>
        任务来源 {{source_filter.length || ''}}
      </span>
      <template slot="dropdown">
        <el-dropdown-menu class="filter-status-dropdown">
          <div class="reset">
            <span class="title">任务来源</span>
            <span class="btnHover btn" :class="{'disabled': source_filter.length === 0}" @click="reset">重置</span>
          </div>
          <el-dropdown-item
          v-for="(item, index) in dataset"
          :key="index"
          :command="item"
          >
            <span>{{item.label}}</span>
            <el-switch v-model="item.value" size="mini" @change="handleCommand"></el-switch>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      dataset: [{
        label: '我执行的',
        value: false,
        key: 1
      }, {
        label: '我参与的',
        value: false,
        key: 2
      }, {
        label: '我创建的',
        value: false,
        key: 3
      }, {
        label: '我关注的',
        value: false,
        key: 4
      }]
    }
  },
  computed: {
    ...mapState('task/task', {
      source_filter: state => state.queryMsg.source_filter
    })
  },
  created() {
    this.dataset.forEach(res => {
      this.$set(res, 'value', this.source_filter.indexOf(res.key) > -1)
    })
  },
  methods: {
    ...mapMutations('task/task', ['set_source_filter']),
    handleCommand() {
      this.set_source_filter(this.dataset.filter(res => res.value).map(res => res.key))
    },
    reset() {
      if(this.source_filter.length > 0) {
        this.dataset.map(res => {
          res.value = false
        })
        this.set_source_filter([])
      }
    }
  }
}
</script>
<style lang="scss">
// .filter-status-dropdown {
//   .el-switch.is-checked .el-switch__core::after {
//     margin-left: -15px;
//   }
//   .el-switch {
//     width: 32px;
//   }
//   .el-switch__core {
//     height: 18px;
//     width: 32px !important;
//     &::after {
//       width: 14px;
//       height: 14px;
//     }
//   }
// }
</style>
